import { render } from "./ListItem.vue?vue&type=template&id=0661a03c&scoped=true"
import script from "./ListItem.vue?vue&type=script&lang=js"
export * from "./ListItem.vue?vue&type=script&lang=js"

import "./ListItem.vue?vue&type=style&index=0&id=0661a03c&lang=scss&scoped=true"

import exportComponent from "/Users/matteomelillo/Dev/vueApps/ronchipiero.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0661a03c"]])

export default __exports__